module.exports = __webpack_public_path__ + "static/AW_kid-46dd1a4d60b1ec0a18c4755baccbccae.jpg";